import {
    CategoryTextSortDto,
    CategoryTextSortUpdateDto,
    FaqDto,
    FlagDto,
    ImporterDto,
    LanguageCnrDto,
    Link,
    MenuDto,
    ModelyearDto,
    NewsDto,
    ProMTGroupDto,
    ResourceListOfCategoryTextSortDto, ResourceListOfFaqDto,
    ResourceListOfFlagDto,
    ResourceListOfGroupDto,
    ResourceListOfLanguageCnrDto,
    ResourceListOfNewsDto,
    ResourceListOfPrivilegeDto,
    ResourceListOfProMTGroupDto,
    ResourceListOfRoleDto,
    ResourceListOfSpecConfigurationDto,
    ResourceListOfUserDto,
    SpecDto
} from "../../services/Client";
import {AnyAction} from "redux";
import {Dispatch} from "react-redux";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import {Helpers} from "../reducers/Helpers";
import {ActionTypes} from "./ActionTypes";
import GeneralActions from "./GeneralActions";
import {GetMYCategoryParams, UpdateFaqPositionParams, UpdateNewsPositionParams} from "../../services/HATEOASClient";
import {IReduxState} from "../IReduxState";
import {selectAdminArealinks, selectClient, selectProMTGroups} from "../selectors";

const AdminViewActions = {
    ReceiveAdminareaLinks(dto: MenuDto): AnyAction {
        return {type: ActionTypes.RECEIVE_ADMINAREA_LINKS, adminAreaLinks: dto};
    },
    ReceiveImporterList(importerList: ImporterDto[]): AnyAction {
        return {type: ActionTypes.RECEIVE_IMPORTER_LIST, importerList: importerList};
    },
    ReceiveUsers(users: ResourceListOfUserDto) {
        return {type: ActionTypes.RECEIVE_USERS, users: users};
    },
    GetUsers(t: reactI18Next.TranslationFunction, setLoading: (flag: boolean) => void) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const client = selectClient(getState());
            const adminAreaLinks = selectAdminArealinks(getState());

            if (!adminAreaLinks ||
                !client.GET_userList(adminAreaLinks).canExecute()) {
                renderErrorToast({
                    message: "ERRORS:GET_USERS",
                    timestamp: Date.now()
                });
            } else {
                setLoading(true);
                client.GET_userList(adminAreaLinks).execute()
                    .then((value: ResourceListOfUserDto) => {
                        dispatch(this.ReceiveUsers(value));
                        setLoading(false);
                    })
                    .catch((reason: any) => {
                        window.scrollTo(0, 0);
                        renderErrorToast({
                            message: "ERRORS:GET_USERS",
                            details: reason,
                            timestamp: Date.now()
                        });
                        setLoading(false);
                    });
            }
        };
    },
    ReceiveGroups(groups: ResourceListOfGroupDto) {
        return {type: ActionTypes.RECEIVE_GROUPS, groups: groups};
    },
    GetGroups(t: reactI18Next.TranslationFunction, setLoading: (flag: boolean) => void) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const client = selectClient(getState());
            const adminAreaLinks = selectAdminArealinks(getState());

            if (!adminAreaLinks ||
                !client.GET_groupList(adminAreaLinks).canExecute()) {
                renderErrorToast({
                    message: "ERRORS:GET_GROUPS",
                    timestamp: Date.now()
                });
            } else {
                setLoading(true);
                client.GET_groupList(adminAreaLinks).execute()
                    .then((value: ResourceListOfGroupDto) => {
                        dispatch(this.ReceiveGroups(value));

                        // request was successfully fulfilled; reset loading state
                        setLoading(false);
                    })
                    .catch((reason: any) => {
                        window.scrollTo(0, 0);
                        renderErrorToast({
                            message: "ERRORS:GET_GROUPS",
                            details: reason,
                            timestamp: Date.now()
                        });
                        setLoading(false);
                    });
            }
        };
    },
    ReceiveProMTGroups(groups: ResourceListOfProMTGroupDto) {
        return {type: ActionTypes.RECEIVE_PROMT_GROUPS, groups: groups};
    },
    GetProMTGroups(t: reactI18Next.TranslationFunction, setLoading: (flag: boolean) => void) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const client = selectClient(getState());
            const adminAreaLinks = selectAdminArealinks(getState());

            if (!adminAreaLinks ||
                !client.GET_proMTGroupList(adminAreaLinks).canExecute()) {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:GET_PROMT_GROUPS",
                    timestamp: Date.now()
                }
                );
            } else {
                setLoading(true);
                client.GET_proMTGroupList(adminAreaLinks).execute()
                    .then((value: ResourceListOfProMTGroupDto) => {
                        if (!value || !value.elements) {
                            renderErrorToast({
                                message: "ERRORS:GET_PROMT_GROUPS",
                                details: "NO_PROMT_GROUPS_FOUND",
                                timestamp: Date.now()
                            });
                            setLoading(false);
                            return;
                        }
                        // Iterate over value.elements and update assignedTypefamilies
                        value.elements = value.elements.map((element: any) => ({
                            ...element,
                            assignedTypefamilies: element.assignedTypefamilies.map((typefamily: any) => ({
                                ...typefamily,
                                key: typefamily.typefamily === 'M' ? 'M_TYPEFAMILY' : typefamily.typefamily, // Add key property
                            })),
                        }));

                        dispatch(this.ReceiveProMTGroups(value));
                        setLoading(false);
                    })
                    .catch((reason: any) => {
                        window.scrollTo(0, 0);
                        renderErrorToast({
                            message: "ERRORS:GET_PROMT_GROUPS",
                            details: reason,
                            timestamp: Date.now()
                        });
                        setLoading(false);
                    });
            }
        };
    },
    CreateProMTGroup(groupName: string, t: reactI18Next.TranslationFunction, setLoading: (flag: boolean) => void) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const client = selectClient(getState());
            const proMTGroups = selectProMTGroups(getState());

            setLoading(true);

            if (proMTGroups) {
                const newGroup: ProMTGroupDto = {
                    groupName: groupName,
                    objectId: 0, // dummy objectId for creation
                    versionId: 0, // dummy versionId for creation
                };
                client.POST_proMTGroup(proMTGroups).execute(newGroup)
                    .then(() => {
                        dispatch(this.GetProMTGroups(t, setLoading));
                    })
                    .catch((reason: any) => {
                        window.scrollTo(0, 0);
                        renderErrorToast({
                            message: "ERRORS:CREATE_PROMT_GROUP",
                            translationOptions: {groupName},
                            details: reason,
                            timestamp: Date.now()
                        });
                        setLoading(false);
                    });
            }
        };
    },
    UpdateProMTGroup(oldGroup: ProMTGroupDto, newGroup: ProMTGroupDto, t: reactI18Next.TranslationFunction, setLoading: (flag: boolean) => void) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const client = selectClient(getState());

            setLoading(true);

            client.PATCH_proMTGroup(oldGroup).execute(newGroup)
                .then((_: Link) => {
                    dispatch(this.GetProMTGroups(t, setLoading));
                })
                .catch((reason: any) => {
                    window.scrollTo(0, 0);
                    renderErrorToast({
                        message: "ERRORS:UPDATE_PROMT_GROUP",
                        translationOptions: {groupName: oldGroup.groupName},
                        details: reason,
                        timestamp: Date.now()
                    });
                    setLoading(false);
                });
        };
    },
    DeleteProMTGroup(proMTGroupDto: ProMTGroupDto, t: reactI18Next.TranslationFunction, setLoading: (flag: boolean) => void) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const client = selectClient(getState());

            setLoading(true);
            client.DELETE_proMTGroup(proMTGroupDto).execute(proMTGroupDto)
                .then((_: any) => {
                    dispatch(this.GetProMTGroups(t, setLoading));
                })
                .catch((reason: any) => {
                    window.scrollTo(0, 0);
                    renderErrorToast({
                        message: "ERRORS:DELETE_PROMT_GROUP",
                        translationOptions: {groupName: proMTGroupDto.groupName},
                        details: reason,
                        timestamp: Date.now()
                    });
                    setLoading(false);
                });
        };
    },
    ReceiveRoles(roles: ResourceListOfRoleDto) {
        return {type: ActionTypes.RECEIVE_ROLES, roles: roles};
    },
    GetRoles(t: reactI18Next.TranslationFunction, setLoading: (flag: boolean) => void) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const client = selectClient(getState());
            const adminAreaLinks = selectAdminArealinks(getState());

            if (!adminAreaLinks ||
                !client.GET_roleList(adminAreaLinks).canExecute()) {
                renderErrorToast({
                    message: "ERRORS:GET_ROLES",
                    timestamp: Date.now()
                });
            } else {
                setLoading(true);
                client.GET_roleList(adminAreaLinks).execute()
                    .then((value: ResourceListOfRoleDto) => {
                        dispatch(this.ReceiveRoles(value));

                        // request was successfully fulfilled; reset loading state
                        setLoading(false);
                    })
                    .catch((reason: any) => {
                        window.scrollTo(0, 0);
                        renderErrorToast({
                            message: "ERRORS:GET_ROLES",
                            details: reason,
                            timestamp: Date.now()
                        });
                        setLoading(false);
                    });
            }
        };
    },
    ReceivePrivileges(privileges: ResourceListOfPrivilegeDto) {
        return {type: ActionTypes.RECEIVE_PRIVILEGES, privileges: privileges};
    },
    GetSpecConfigurations(t: reactI18Next.TranslationFunction, links?: MenuDto, passive?: boolean) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            if (links === undefined) {
                renderErrorToast({message: "ERRORS:GET_SPEC_CONFIG_DATA", details: "BASELINK_NOT_FOUND", timestamp: Date.now()});
            } else {
                Helpers.getSomethingWithLinks<ResourceListOfSpecConfigurationDto>(
                    dispatch,
                    getState(),
                    links,
                    "GET_specConfigList",
                    "loadingSpecConfis",
                    (val) => this.ReceivedSpecConfigurations(val),
                    t("LOAD_SPEC_CONFIG"),
                    t("ERRORS:GET_SPEC_CONFIG_DATA"),
                    undefined,
                    undefined,
                    passive);
            }
        };
    },
    ReceivedSpecConfigurations(data?: ResourceListOfSpecConfigurationDto) {
        return {type: ActionTypes.RECEIVE_SPEC_CONFIGS, data: data};
    },
    ReceiveSpecs(specs?: SpecDto[]) {
        return {type: ActionTypes.RECEIVE_SPECS, specs: specs};
    },
    UnloadDerivates() {
        return {type: ActionTypes.UNLOAD_DERIVATES};
    },
    CreateTextFlag(t: reactI18Next.TranslationFunction, links: ResourceListOfFlagDto, dto: FlagDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (links && links.links && client.POST_flag(links).canExecute()) {
                const loadingScreenMessage = t('TEXT_FLAG:POST_FLAG');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.POST_flag(links).execute(dto)
                    .then((_: Link) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetTextFlags(t));
                    })
                    .catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        window.scrollTo(0, 0);

                        renderErrorToast({
                            message: "ERRORS:CREATE_FLAG",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:CREATE_FLAG",
                    timestamp: Date.now()
                }
                );
            }
        };
    },
    DeleteTextFlag(t: reactI18Next.TranslationFunction, dto: FlagDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (client.DELETE_flag(dto).canExecute()) {
                const loadingScreenMessage = t('TEXT_FLAG:DELETING_FLAG');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.DELETE_flag(dto).execute(dto)
                    .then(() => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetTextFlags(t));
                    })
                    .catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        window.scrollTo(0, 0);

                        renderErrorToast({
                            message: "ERRORS:DELETE_FLAG",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:DELETE_FLAG",
                    timestamp: Date.now()
                }
                );
            }
        };
    },
    UpdateTextFlag(t: reactI18Next.TranslationFunction, dto: FlagDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (client.PATCH_flag(dto).canExecute()) {
                const loadingScreenMessage = t('TEXT_FLAG:UPDATE_FLAG');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.PATCH_flag(dto).execute(dto)
                    .then(() => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetTextFlags(t));
                    })
                    .catch((reason) => {
                        window.scrollTo(0, 0);
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetTextFlags(t));

                        renderErrorToast({
                            message: "ERRORS:UPDATE_FLAG",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:UPDATE_FLAG",
                    timestamp: Date.now()
                });
            }
        };
    },
    GetTextFlags(t: reactI18Next.TranslationFunction) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client, baseLinks} = getState().general;

            if (!baseLinks || !client.GET_flags(baseLinks).canExecute()) {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:GET_FLAGS",
                    timestamp: Date.now()
                });
            } else {
                const loadingScreenMessage = t('TEXT_FLAG:LOAD_FLAGS');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));
                client.GET_flags(baseLinks).execute()
                    .then((result: ResourceListOfFlagDto) => {
                        dispatch(this.ReceiveFlags(result));
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    }).catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        renderErrorToast({
                            message: "ERRORS:GET_FLAGS",
                            details: reason,
                            timestamp: Date.now()
                        }
                        );
                    });
            }
        };
    },
    ReceiveFlags(flags: ResourceListOfFlagDto) {
        return {type: ActionTypes.RECEIVE_FLAGS, flags};
    },
    CreateNews(t: reactI18Next.TranslationFunction, links: ResourceListOfNewsDto, dto: NewsDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (links && links.links && client.POST_news(links).canExecute()) {
                const loadingScreenMessage = t('NOTES_AND_NEWS:CREATE_NEWS');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.POST_news(links).execute(dto)
                    .then((_: Link) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetNews(t));
                    })
                    .catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        window.scrollTo(0, 0);

                        renderErrorToast({
                            message: "ERRORS:CREATE_NEWS",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:CREATE_NEWS",
                    timestamp: Date.now()
                }
                );
            }
        };
    },
    DeleteNews(t: reactI18Next.TranslationFunction, dto: NewsDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (client.DELETE_news(dto).canExecute()) {
                const loadingScreenMessage = t('NOTES_AND_NEWS:DELETING_NEWS');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.DELETE_news(dto).execute(dto)
                    .then(() => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetNews(t));
                    })
                    .catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        window.scrollTo(0, 0);

                        renderErrorToast({
                            message: "ERRORS:DELETE_NEWS",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:DELETE_NEWS",
                    timestamp: Date.now()
                }
                );
            }
        };
    },
    UpdateNews(t: reactI18Next.TranslationFunction, dto: NewsDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (client.PATCH_news(dto).canExecute()) {
                const loadingScreenMessage = t('NOTES_AND_NEWS:UPDATE_NEWS');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.PATCH_news(dto).execute(dto)
                    .then(() => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetNews(t));
                    })
                    .catch((reason) => {
                        window.scrollTo(0, 0);
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetNews(t));

                        renderErrorToast({
                            message: "ERRORS:UPDATE_NEWS",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:UPDATE_NEWS",
                    timestamp: Date.now()
                });
            }
        };
    },
    GetNews(t: reactI18Next.TranslationFunction) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client, baseLinks} = getState().general;

            if (!baseLinks || !client.GET_news(baseLinks).canExecute()) {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:GET_NEWS",
                    timestamp: Date.now()
                }
                );
            } else {
                const loadingScreenMessage = t('NOTES_AND_NEWS:GET_NEWS');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));
                client.GET_news(baseLinks).execute()
                    .then((result: ResourceListOfNewsDto) => {
                        dispatch(this.ReceiveNews(result));
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    }).catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        renderErrorToast({
                            message: "ERRORS:GET_NEWS",
                            details: reason,
                            timestamp: Date.now()
                        }
                        );
                    });
            }
        };
    },
    ReceiveNews(news: ResourceListOfNewsDto) {
        return {type: ActionTypes.RECEIVE_NEWS, news};
    },
    UpdateNewsPosition(t: reactI18Next.TranslationFunction, dto: NewsDto, toPosition: number) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (client.PATCH_moveNews(dto).canExecute()) {
                const loadingScreenMessage = t('NOTES_AND_NEWS:MOVE_NEWS');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                const reqParam: UpdateNewsPositionParams = {
                    toPosition,
                };

                client.PATCH_moveNews(dto).execute(reqParam)
                    .then(() => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetNews(t));
                    })
                    .catch((reason) => {
                        window.scrollTo(0, 0);
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetNews(t));

                        renderErrorToast({
                            message: "ERRORS:MOVE_NEWS",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:MOVE_NEWS",
                    timestamp: Date.now()
                });
            }
        };
    },
    GetActiveNews(t: reactI18Next.TranslationFunction) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client, baseLinks} = getState().general;

            if (!baseLinks || !client.GET_activeNews(baseLinks).canExecute()) {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:GET_NEWS",
                    timestamp: Date.now()
                }
                );
            } else {
                const loadingScreenMessage = t('NOTES_AND_NEWS:GET_ACTIVE_NEWS');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));
                client.GET_activeNews(baseLinks).execute()
                    .then((result: NewsDto[]) => {
                        dispatch(this.ReceiveActiveNews(result));
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    }).catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        renderErrorToast({
                            message: "ERRORS:GET_NEWS",
                            details: reason,
                            timestamp: Date.now()
                        }
                        );
                    });
            }
        };
    },
    ReceiveActiveNews(news: NewsDto[]) {
        return {type: ActionTypes.RECEIVE_ACTIVE_NEWS, news};
    },

    CreateFaq(t: reactI18Next.TranslationFunction, links: ResourceListOfFaqDto, dto: FaqDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (links && links.links && client.POST_faq(links).canExecute()) {
                const loadingScreenMessage = t('FAQ:CREATE_FAQ');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.POST_faq(links).execute(dto)
                    .then((_: Link) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetFaqs(t));
                    })
                    .catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        window.scrollTo(0, 0);

                        renderErrorToast({
                            message: "ERRORS:CREATE_FAQ",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                        message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                        details: "ERRORS:CREATE_FAQ",
                        timestamp: Date.now()
                    }
                );
            }
        };
    },
    DeleteFaq(t: reactI18Next.TranslationFunction, dto: FaqDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (client.DELETE_faq(dto).canExecute()) {
                const loadingScreenMessage = t('FAQ:DELETING_FAQ');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.DELETE_faq(dto).execute(dto)
                    .then(() => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetFaqs(t));
                    })
                    .catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        window.scrollTo(0, 0);

                        renderErrorToast({
                            message: "ERRORS:DELETE_FAQ",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                        message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                        details: "ERRORS:DELETE_FAQ",
                        timestamp: Date.now()
                    }
                );
            }
        };
    },
    UpdateFaq(t: reactI18Next.TranslationFunction, dto: FaqDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (client.PATCH_faq(dto).canExecute()) {
                const loadingScreenMessage = t('FAQ:UPDATE_FAQ');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.PATCH_faq(dto).execute(dto)
                    .then(() => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetFaqs(t));
                    })
                    .catch((reason) => {
                        window.scrollTo(0, 0);
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetFaqs(t));

                        renderErrorToast({
                            message: "ERRORS:UPDATE_FAQ",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:UPDATE_FAQ",
                    timestamp: Date.now()
                });
            }
        };
    },
    GetFaqs(t: reactI18Next.TranslationFunction) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;
            const {adminAreaLinks} = getState().administration;

            if (!adminAreaLinks || !client.GET_faq(adminAreaLinks).canExecute()) {
                renderErrorToast({
                        message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                        details: "ERRORS:GET_FAQ",
                        timestamp: Date.now()
                    }
                );
            } else {
                const loadingScreenMessage = t('FAQ:GET_FAQS');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));
                client.GET_faq(adminAreaLinks).execute()
                    .then((result: ResourceListOfFaqDto) => {
                        dispatch(this.ReceiveFaqs(result));
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    }).catch((reason) => {
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    renderErrorToast({
                            message: "ERRORS:GET_FAQS",
                            details: reason,
                            timestamp: Date.now()
                        }
                    );
                });
            }
        };
    },
    ReceiveFaqs(faqs: ResourceListOfFaqDto) {
        return {type: ActionTypes.RECEIVE_FAQS, faqs};
    },
    UpdateFaqPosition(t: reactI18Next.TranslationFunction, dto: FaqDto, toPosition: number) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (client.PATCH_moveFaq(dto).canExecute()) {
                const loadingScreenMessage = t('FAQ:MOVE_FAQ');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                const reqParam: UpdateFaqPositionParams = {
                    toPosition,
                };

                client.PATCH_moveFaq(dto).execute(reqParam)
                    .then(() => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetFaqs(t));
                    })
                    .catch((reason) => {
                        window.scrollTo(0, 0);
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetFaqs(t));

                        renderErrorToast({
                            message: "ERRORS:MOVE_FAQ",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:MOVE_FAQ",
                    timestamp: Date.now()
                });
            }
        };
    },

    GetModelyearCategories(t: reactI18Next.TranslationFunction, modelyear: ModelyearDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;
            const {adminAreaLinks} = getState().administration;

            if (!adminAreaLinks || !client.GET_modelyearCategories(adminAreaLinks).canExecute()) {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:GET_MODELYEAR_CATEGORIES",
                    timestamp: Date.now()
                }
                );
            } else {
                const loadingScreenMessage = t("CATEGORY_SORT:GET_MODELYEAR_CATEGORIES", {mj4: modelyear.mj4});
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));
                const param: GetMYCategoryParams = {
                    modelyearId: modelyear.objectId
                };
                client.GET_modelyearCategories(adminAreaLinks).execute(param)
                    .then((result: ResourceListOfCategoryTextSortDto) => {
                        dispatch(this.ReceiveModelyearCategories(result.elements || []));
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    }).catch((reason) => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        renderErrorToast({
                            message: "ERRORS:GET_MODELYEAR_CATEGORIES",
                            details: reason,
                            timestamp: Date.now()
                        }
                        );
                    });
            }
        };
    },
    ReceiveModelyearCategories(modelyearCategories: CategoryTextSortDto[]) {
        return {type: ActionTypes.RECEIVE_MODELYEAR_CATEGORIES, modelyearCategories};
    },
    UnloadModelyearCategories() {
        return {type: ActionTypes.UNLOAD_MODELYEAR_CATEGORIES};
    },
    UpdateCategoryPosition(t: reactI18Next.TranslationFunction, dto: CategoryTextSortDto[], toPosition: number, modelyear: ModelyearDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (client.PATCH_moveCategory(dto[0]).canExecute()) {
                const loadingScreenMessage = t("CATEGORY_SORT:MOVE_CATEGORY");
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                const param: CategoryTextSortUpdateDto = {
                    categoryTextSortDto: dto,
                    toPosition: toPosition
                };

                client.PATCH_moveCategory(dto[0]).execute(param)
                    .then(() => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetModelyearCategories(t, modelyear));
                    })
                    .catch((reason) => {
                        window.scrollTo(0, 0);
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetModelyearCategories(t, modelyear));

                        renderErrorToast({
                            message: "ERRORS:MOVE_CATEGORY",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:MOVE_CATEGORY",
                    timestamp: Date.now()
                });
            }
        };
    },
    ChangeActiveAccesTab(payload: {
        activeIndex: number;
        filter?: string;
    }) {
        return {type: ActionTypes.CHANGE_ACTIVE_ACCESSTAB, payload};
    },
    GetCnrLanguages(t: reactI18Next.TranslationFunction) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;
            const {adminAreaLinks} = getState().administration;

            if (!adminAreaLinks || !client.GET_cnrLanguages(adminAreaLinks).canExecute()) {
                renderErrorToast({
                                     message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                                     details: "ERRORS:GET_CNR_LANGUAGES",
                                     timestamp: Date.now()
                                 }
                );
            } else {
                const loadingScreenMessage = t("LANGUAGES:GET_CNR_LANGUAGES");
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.GET_cnrLanguages(adminAreaLinks).execute()
                    .then((result: ResourceListOfLanguageCnrDto) => {
                        dispatch(this.ReceiveCnrLanguages(result || []));
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    }).catch((reason) => {
                    dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                    renderErrorToast({
                                         message: "ERRORS:GET_CNR_LANGUAGES",
                                         details: reason,
                                         timestamp: Date.now()
                                     }
                    );
                });
            }
        };
    },
    ReceiveCnrLanguages(cnrlanguages: ResourceListOfLanguageCnrDto) {
        return {type: ActionTypes.RECEIVE_CNR_LANGUAGES, cnrlanguages};
    },
    UpdateCnrLanguages(t: reactI18Next.TranslationFunction, dto: LanguageCnrDto) {
        return (dispatch: Dispatch<IReduxState>, getState: () => IReduxState) => {
            const {client} = getState().general;

            if (client.PATCH_assignLanguageCnr(dto).canExecute()) {
                const loadingScreenMessage = t('LANGUAGES:UPDATE_CNR_LANGUAGES');
                dispatch(GeneralActions.AddLoadingMessage(loadingScreenMessage));

                client.PATCH_assignLanguageCnr(dto).execute(dto)
                    .then(() => {
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetCnrLanguages(t));
                    })
                    .catch((reason) => {
                        window.scrollTo(0, 0);
                        dispatch(GeneralActions.RemoveLoadingMessage(loadingScreenMessage));
                        dispatch(this.GetCnrLanguages(t));

                        renderErrorToast({
                                             message: "ERRORS:UPDATE_CNR_LANGUAGES",
                                             details: reason,
                                             timestamp: Date.now()
                                         });
                    });
            } else {
                renderErrorToast({
                                     message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                                     details: "ERRORS:UPDATE_CNR_LANGUAGES",
                                     timestamp: Date.now()
                                 });
            }
        };
    },
};

export default AdminViewActions;



// WEBPACK FOOTER //
// ./src/redux/actions/AdminViewActions.tsx